import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as BackupLocationActions from './backup-locations.actions';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { PublicPartnerApiService } from '../../@shared/services/publicpartnerapi.service';

@Injectable()
export class BackupLocationEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly api: PublicPartnerApiService
  ) { }


  loadLocation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BackupLocationActions.loadBackupLocations),
      switchMap(action => this.api.get<any>('/partners/backup_locations').pipe(
        map(result => BackupLocationActions.loadBackupLocationsSuccess({
          backup_locations: result.backup_locations
        })),
        catchError(error => of(BackupLocationActions.loadBackupLocationsFailure({ error })))
      ))
    )
  )
}
